<template>
    <div>
        <data-grid
            url="ivrCalls"
            baseUrl="https://dinner-compaign.azurewebsites.net"
            :columns="columns"
            :title="title"
            :sortOptions="{
                enabled: true,
                field: 'date',
                type: 'desc',
            }"
            :expandedOptions="{
                enabled: true,
                template: 'dinner-ivr-call-details',
            }"
            ref="grid"
        ></data-grid>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "IVR Calls",
        columns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                field: "nameH",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Donor ID",
                field: "id",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: true,
                label: "Date",
                field: "date",
                type: "date",
                dateOutputFormat: "MM/DD/YYYY h:mm:ss A",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    startDate: moment()
                        .subtract(1, "month")
                        .add(1, "day")
                        .format(),
                },
            },
            {
                sortable: false,
                label: "Caller ID",
                field: "callerID",
                hidden: false,
                formatFn: (value) => {
                    if (!value) return "";

                    value =
                        value.length > 10
                            ? value.substring(value.length - 10)
                            : value;

                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    methods: {},
};
</script>
<style>
[v-cloak] {
    display: none;
}
.action-tile .v-list__tile {
    height: 65px;
}
</style>
